<div class="p-2 pb-14 flex-1 h-full  overflow-y-auto">
    <div
    class="max-w-6xl p-4 rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 shadow-lg">
    <form [formGroup]="companyForm" (ngSubmit)="onSave()">
        <h1 class="heading">
            {{companyId ? 'Edit' : 'Add'}}
        </h1>
        <hr class="my-4 mt-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
        <div class="flex items-center justify-between">
             <label class="heading">
            <h2>General Information</h2>
        </label>
        </div>
        <section class="grid gap-4 sm:grid-cols-2">
            <div class="space-y-1">
                <label class="subheading">
                    Name <span class="text-red-600">*</span>
                </label>
                <div>
                    <div>
                        <input formControlName="name" type="text" [readOnly]="verification?.isName"
                            [ngClass]="verification?.isName ? '': 'border-red-600 dark:border-red-600'"  />
                    </div>
                    <div *ngIf="submitted && form.name.errors">
                        <p *ngIf="form.name.errors.required" class="pt-1 text-red-600 text-xs">
                             Name is required
                        </p>
                    </div>
                </div>
            </div>
            <div class="space-y-1">
                <label class="subheading">
                    Email <span class="text-red-600">*</span>
                </label>
                <div>
                    <div>
                        <input formControlName="email" type="email" [readOnly]="verification.isEmail"
                            [ngClass]="verification.isEmail ? '': 'border-red-600 dark:border-red-600'"/>
                    </div>
                    <div *ngIf="submitted && form.email.errors">
                        <p *ngIf="form.email.errors.required" class="pt-1 text-red-600 text-xs">
                            Email is required
                        </p>
                        <p *ngIf="form.email.errors.email" class="pt-1 text-red-600 text-xs">
                            Valid Email is required
                        </p>
                    </div>

                </div>
            </div>
            <ng-container formGroupName="address">
                <div class="space-y-1">
                    <label class="subheading">
                        Address <span class="text-red-600">*</span>
                    </label>
                    <div>
                        <!-- Input with googlePlace directive -->
                        <input *ngIf="!verification.address?.isName" googlePlace (onSelect)="onSelectAddress($event)" (input)="onChangeOriginAddress()"
                            formControlName="name" type="text" [disabled]="verification.address?.isName"
                            [readOnly]="verification.address?.isName"
                            [ngClass]="verification.address?.isName ? '' : 'border-red-600 dark:border-red-600'" 
                            placeholder="Enter the address" />

                        <!-- Input without googlePlace directive -->
                        <input *ngIf="verification.address?.isName" (onSelect)="onSelectAddress($event)" formControlName="name"
                            type="text" [disabled]="verification.address?.isName"
                            [readOnly]="verification.address?.isName"
                            [ngClass]="verification.address?.isName ? '' : 'border-red-600 dark:border-red-600'" 
                            placeholder="Enter the address" />
                    
                        <div *ngIf="submitted">
                            <p *ngIf="address.get('name')?.errors?.required" class="pt-1 text-red-600 text-xs">
                                Address is required
                            </p>
                             <p *ngIf="address?.errors?.invalidAddress" class="mt-2 text-red-600 text-xs">
                              Invalid address (select from the dropdown)
                            </p>
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        City <span class="text-red-600">*</span>
                    </label>
                    <div>
                        <input formControlName="city" type="text" placeholder=""
                            [readOnly]="verification.address?.isCity"
                            [ngClass]="verification.address?.isCity ? '': 'border-red-600 dark:border-red-600'" />
                            <div *ngIf="submitted && address.get('city')?.errors">
                                <p *ngIf="address.get('city')?.errors?.required" class="pt-1 text-red-600 text-xs">
                                    City is required
                                </p>
                            </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        State <span class="text-red-600">*</span>
                    </label>
                    <div>
                        <input formControlName="state" type="text" placeholder=""
                            [readOnly]="verification.address?.isState"
                            [ngClass]="verification.address?.isState ? '': 'border-red-600 dark:border-red-600'"  />
                    <div *ngIf="submitted && address.get('state')?.errors">
                        <p *ngIf="address.get('state')?.errors?.required" class="pt-1 text-red-600 text-xs">
                            State is required
                        </p>
                    </div>
                        </div>
                </div>
            </ng-container>

            <div class="space-y-1">
                <label class="subheading">
                    Contact Number <span class="text-red-600">*</span>
                </label>
                <div>
                    <input formControlName="phoneNumber" type="text" placeholder="" class="[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                        [readOnly]="verification.isPhoneNumber"
                        [ngClass]="verification.isPhoneNumber ? '': 'border-red-600 dark:border-red-600'" />
                    <div *ngIf="submitted && form.phoneNumber.errors">
                        <p *ngIf="form.phoneNumber.errors.required" class="pt-1 text-red-600 text-xs">
                            Contact Number is required
                        </p>
                        <p *ngIf="submitted && form.phoneNumber.errors?.minlength || submitted && form.phoneNumber.errors.maxlength"
                            class="pt-1 text-red-600 text-xs">
                            Minimum 10 digits are required and maximum 13 digits are allowed
                        </p>
                    </div>
                </div>
            </div>
            <div class="space-y-1">
                <label class="subheading">
                    Secondary Contact Number
                </label>
                <div>
                    <div>
                        <input formControlName="secondaryPhoneNumber" type="text" class="[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                            [readOnly]="verification.isSecondaryPhoneNumber"
                            [ngClass]="verification.isSecondaryPhoneNumber ? '': 'border-red-600 dark:border-red-600'" />
                            <div *ngIf="submitted && form.secondaryPhoneNumber.errors">
                        <p *ngIf="submitted && form.secondaryPhoneNumber.errors?.minlength || submitted && form.secondaryPhoneNumber.errors.maxlength"
                            class="pt-1 text-red-600 text-xs">
                            Minimum 10 digits are required and maximum 13 digits are allowed
                        </p>
                    </div>
                    </div>
                </div>
            </div>
            <div class="space-y-1">
                <label class="subheading">
                    Time Zone <span class="text-red-600">*</span>
                </label>
                <div>
                    <div>
                        <select formControlName="timeZone" [ngClass]="verification.isTimeZone ? '': 'border-red-600 dark:border-red-600'" >
                            <option [disabled]="verification.isTimeZone" value="">
                                Select the Time Zone
                            </option>
                            <option [disabled]="verification.isTimeZone" *ngFor="let item of allTimezones"
                                value="{{item}}">
                                {{item}}
                            </option>
                        </select>
                    </div>
                </div>
                <div *ngIf="form.timeZone.errors && submitted">
                    <div *ngIf="form.timeZone.errors.required" class="error">
                        <p class="mt-2 text-red-600 text-xs">
                            Time Zone is required
                        </p>
                    </div>
                </div>
            </div>

            <!-- webURL -->
               <div class="space-y-1">
                <label class="subheading">
                    Web URL
                </label>
                <div>
                    <div>
                        <input formControlName="webURL" type="text"
                            [readonly]="verification.isWebURL"
                            [ngClass]="verification.isWebURL ? '': 'border-red-600 dark:border-red-600'"  />
                    </div>
                </div>
            </div>
            
            <!-- <div class="space-y-1">
                <label class="subheading">
                    Hours of Operation
                </label>
                <div>
                    <div>
                        <input formControlName="hoursofOperation" type="text"
                            [readonly]="verification.isHoursofOperation"
                            [ngClass]="verification.isHoursofOperation ? '': 'border-red-600 dark:border-red-600'"  />
                    </div>
                </div>
            </div> -->            
            <div class="space-y-1">
                <label class="subheading">Service Area(s) <span class="text-red-600">*</span></label>
                <div class="rounded-lg" [ngClass]="verification.isServiceAreas ? '': 'border border-red-600 dark:border-red-600'">
                    <!-- Using items input with multiple selection -->
                    <ng-select [ngModelOptions]="{standalone: true}" [items]="serviceAreas"
                        bindLabel="title" bindValue="id" [(ngModel)]="selectedServiceArea"
                        [multiple]="true" [clearable]="false" [closeOnSelect]="false" [readonly]="verification.isServiceAreas"
                        placeholder="-- Select Service Areas --" [searchable]="true"
                        (change)="onSelectServiceAreas()">
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <input id="item-{{index}}" type="checkbox" [ngModelOptions]="{standalone: true}"
                                [ngModel]="item$.selected" />
                            {{(item.title) | titlecase }}
                        </ng-template>
                    </ng-select>
                </div>
                <div *ngIf="form.serviceAreas.errors && submitted">
                    <div *ngIf="form.serviceAreas.errors.required" class="error">
                        <p class="mt-2 text-red-600 text-xs">
                            Service Area(s) are required
                        </p>
                    </div>
                </div>
            </div>
            
            <div class="col-span-2 mt-4">
              <div class="space-y-2 p-4  rounded-lg dark:bg-zinc-900 border 
                shadow-lg"
                [ngClass]="verification.isHoursofOperation 
                    ? 'bg-gray-100 border-zinc-950/10 dark:border-white/10' 
                    : 'bg-white border-red-600 dark:border-red-600'">

                <div class="flex items-center gap-2 mb-6">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-blue-500" fill="none" viewBox="0 0 24 24"
                        stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <label class="subheading">Hours of Operation</label>
                </div>
                <div>
                    <div>
                        <div class="grid grid-cols-8 gap-2">
                            <div class="col-span-1">
                                <div class="space-y-2">
                                    <div class="flex items-center h-8">
                                        <p class="text-center text-sm font-medium">Days</p>
                                    </div>
                                    <div class="flex items-center h-8">
                                        <p class="text-center text-sm font-medium">Start Time</p>
                                    </div>
                                    <div class="flex items-center h-8">
                                        <p class="text-center text-sm font-medium">End Time</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-span-7">
                                <div formArrayName="hoursofOperation"  class="grid grid-cols-7 gap-2">
                                    <div *ngFor="let day of operationsArray.controls; let i = index" 
                                        [formGroupName]="i" 
                                        class="space-y-2 p-2"
                                        [ngClass]="{'bg-zinc-950/5 dark:bg-white/5 rounded-md': day.get('enabled')?.value}">
                                        <div class="flex items-center h-8 justify-center">
                                            <p class="text-center text-sm font-medium">
                                                <input formControlName="enabled" type="checkbox" [disabled]="verification.isHoursofOperation" (change)="hoursCheckboxChange(i)" /> {{days[i]}}
                                            </p>
                                        </div>
                                        <div class="flex items-center h-8">
                                            <input type="text" name="start{{i}}" id="start{{i}}" formControlName="startTime" [owlDateTime]="startTime"
                                                [owlDateTimeTrigger]="startTime" 
                                                [readonly]="true" [ngClass]="verification.isHoursofOperation ? 'date-filled' : ''"/>
                                            <owl-date-time [pickerType]="'timer'" #startTime 
                                                [disabled]="verification.isHoursofOperation">
                                            </owl-date-time>
                                        </div>
                                        <div *ngIf="submitted && day.get('startTime')?.errors?.required">
                                            <p class="pt-1 text-red-600 text-xs">Start Time is required</p>
                                        </div>
                                       
                                        <div class="flex items-center h-8">
                                            <input type="text" name="endTime{{i}}" id="endTime{{i}}" formControlName="endTime" [owlDateTime]="endTime"
                                                [owlDateTimeTrigger]="endTime" 
                                                [readonly]="true" [ngClass]="verification.isHoursofOperation ? 'date-filled' : ''"/>
                                            <owl-date-time [pickerType]="'timer'" #endTime 
                                                [disabled]="verification.isHoursofOperation">
                                            </owl-date-time>
                                        </div>
                                         <div *ngIf="submitted && day.get('endTime')?.errors?.required">
                                            <p class="pt-1 text-red-600 text-xs">End Time is required</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>

            <div class="space-y-1 col-span-full">
                <label class="subheading">
                    Company Logo <span class="text-red-600">*</span>
                </label>
                <div class="flex flex-1 gap-2">
                    <div class="flex-1">
                        <div class="relative overflow-hidden rounded-full inline-flex mt-1">
                            <img [src]="profileImageURL ? profileImageURL : 'assets/images/company-placeholder.png'"
                                alt="Profile Image" 
                                class="relative object-cover h-32 w-32 rounded-full border border-main-base"
                                [ngClass]="verification.profileImageURL ? 'border border-main-base' : 'border border-red-600'" />

                            <label 
                                for="Profile"
                                [ngClass]="{
                                    'cursor-not-allowed opacity-50': verification.isProfileImageURL,
                                    'cursor-pointer': !verification.isProfileImageURL
                                }"
                                class="absolute inset-0 flex h-full w-full items-center justify-center bg-black bg-opacity-75 text-sm font-medium text-white opacity-0 focus-within:opacity-100 hover:opacity-100"
                                [title]="verification.isProfileImageURL ? 'Logo cannot be changed after verification' : ''">

                                <!-- Show 'Change' only if logo is editable -->
                                <span *ngIf="!verification.isProfileImageURL">Change</span>

                                <input 
                                    #logoInput 
                                    id="Profile" 
                                    name="Profile Image"
                                    type="file" 
                                    accept="image/*"
                                    class="absolute inset-0 h-full w-full rounded-md border-main-base opacity-0"
                                    [disabled]="verification.isProfileImageURL"
                                    (change)="processFile(logoInput)" />
                            </label>
                        </div>
                    </div>
                </div>
                <div *ngIf="submitted && form.profileImageURL.errors">
                    <p *ngIf="form.profileImageURL.errors.required" class="pt-1 text-red-600 text-xs">
                        Company Logo is required
                    </p>
                </div>
            </div>
        </section>
        <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
        <h2 class="heading">
            Owner Information
        </h2>
        <section class="mt-4 grid gap-4 sm:grid-cols-2">
            <ng-container formGroupName="owner">
                <div class="space-y-1">
                    <label class="subheading">
                        First Name <span class="text-red-600">*</span>
                    </label>
                    <div>
                        <div>
                            <input formControlName="firstName" type="text" [readonly]="verification.owner?.isFirstName"
                                [ngClass]="verification.owner?.isFirstName ? '': 'border-red-600 dark:border-red-600'" />
                        </div>
                        <div *ngIf="submitted && ownerForm.get('firstName')?.errors">
                            <p *ngIf="ownerForm.get('firstName')?.errors?.required" class="pt-1 text-red-600 text-xs">
                                First Name is required
                            </p>
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Middle Name
                    </label>
                    <div>
                        <div>
                            <input formControlName="middleName" type="text" [readonly]="verification.owner?.isMiddleName"
                                [ngClass]="verification.owner?.isMiddleName ? '': 'border-red-600 dark:border-red-600'" />
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Last Name <span class="text-red-600">*</span>
                    </label>
                    <div>
                        <div>
                            <input formControlName="lastName" type="text" [readonly]="verification.owner?.isLastName"
                                [ngClass]="verification.owner?.isLastName ? '': 'border-red-600 dark:border-red-600'" />
                        </div>
                        <div *ngIf="submitted && ownerForm.get('lastName')?.errors">
                            <p *ngIf="ownerForm.get('lastName')?.errors?.required" class="pt-1 text-red-600 text-xs">
                                Last Name is required
                            </p>
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Contact Number <span class="text-red-600">*</span>
                    </label>
                    <div>
                        <div>
                            <input formControlName="phoneNumber" type="text" class="[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                                [readonly]="verification.owner?.isPhoneNumber"
                                [ngClass]="verification.owner?.isPhoneNumber ? '': 'border-red-600 dark:border-red-600'" />
                        </div>
                        <div *ngIf="submitted && ownerForm.get('phoneNumber')?.errors">
                            <p *ngIf="ownerForm.get('phoneNumber')?.errors?.required" class="pt-1 text-red-600 text-xs">
                                Contact Number is required
                            </p>
                            <p *ngIf="submitted && (ownerForm.get('phoneNumber')?.errors?.minlength || ownerForm.get('phoneNumber')?.errors?.maxlength)"
                                class="pt-1 text-red-600 text-xs">
                                Minimum 10 digits are required and maximum 13 digits are allowed
                            </p>
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Email <span class="text-red-600">*</span>
                    </label>
                    <div>
                        <div>
                            <input formControlName="email" type="email" [readonly]="verification.owner?.isEmail"
                                [ngClass]="verification.owner?.isEmail ? '': 'border-red-600 dark:border-red-600'"/>
                        </div>
                        <div *ngIf="submitted && ownerForm.get('email')?.errors">
                            <p *ngIf="ownerForm.get('email')?.errors?.required" class="pt-1 text-red-600 text-xs">
                                Email is required
                            </p>
                            <p *ngIf="ownerForm.get('email')?.errors?.email" class="pt-1 text-red-600 text-xs">
                                Valid Email is required
                            </p>

                        </div>
                    </div>
                </div>
                 <div class="space-y-1">
                    <label class="subheading">
                        Driver's License
                    </label>
                    <div>
                        <div>

                            <input #driverLicenseImageInput type="file" accept="Image/*"
                                [disabled]="verification.owner?.isDriverLicenseImage"
                                [readonly]="verification.owner?.isDriverLicenseImage"
                                [ngClass]="verification.owner?.isDriverLicenseImage ? 'cursor-not-allowed opacity-100' : 'cursor-pointer border-red-600 dark:border-red-600'"
                                (change)="uploadDocumentImages(driverLicenseImageInput, ownerForm.get('driverLicenseImage'))" />
                        </div>
                        <div class="flex justify-between items-center mt-1">
                            <div class="text-xs text-gray-500">
                                <a *ngIf="ownerForm.get('driverLicenseImage')?.value" target="_blank"
                                    [href]="ownerForm.get('driverLicenseImage')?.value"
                                    class="underline text-blue-600 hover:text-blue-800 visited:text-blue-600">
                                    {{ getFileName(ownerForm.get('driverLicenseImage')?.value) }}
                                </a>
                            </div>
                            <div class="flex justify-end gap-2" *ngIf="ownerForm.get('driverLicenseImage')?.value && !verification.owner?.isDriverLicenseImage">
                                <button
                                    type="button"
                                    [appCopyToClipboard]="ownerForm.get('driverLicenseImage')?.value" copyLabel="document link" copyTooltip="Copy link"
                                    class="p-1 border border-zinc-400 rounded bg-white text-black dark:bg-black dark:text-white dark:border-white/40 flex items-center justify-center outline-none focus:outline-none hover:border-primary hover:text-primary dark:hover:border-primary dark:hover:text-primary transition-colors">
                                    <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                                    </svg>
                                </button>
                                <button
                                    (click)="deleteFile(ownerForm.get('driverLicenseImage'), driverLicenseImageInput)"
                                    class="p-1 border rounded bg-red-600 flex items-center justify-center outline-none focus:outline-none">
                                    <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd"
                                            d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                            clip-rule="evenodd"></path>
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <p *ngIf="getRejectionReason('owner','driverLicenseImage')" class="text-sm text-primary mt-1">
                            {{ getRejectionReason('owner','driverLicenseImage') }}
                        </p>
                    </div>
                </div>
                <ng-container formGroupName="address">
                    <div class="space-y-1">
                        <label class="subheading">
                            Address <span class="text-red-600">*</span>
                        </label>
                        <div>
                            <div>
                                <input *ngIf="!verification.owner?.address?.isName" googlePlace (onSelect)="onSelectOwnerAddress($event)"  (input)="onChangeOwnerOriginAddress()" formControlName="name"
                                    [readonly]="verification.owner?.address?.isName"
                                    [ngClass]="verification.owner?.address?.isName ? '': 'border-red-600 dark:border-red-600'" type="text"  placeholder="Enter the address"/>
                                    <input *ngIf="verification.owner?.address?.isName" (onSelect)="onSelectOwnerAddress($event)" formControlName="name"
                                    [readonly]="verification.owner?.address?.isName"
                                    [ngClass]="verification.owner?.address?.isName ? '': 'border-red-600'" type="text"  />
                            </div>
                            <div *ngIf="submitted">
                                <p *ngIf="ownerForm.get('address.name')?.errors?.required"
                                    class="pt-1 text-red-600 text-xs">
                                    Address is required
                                </p>
                                <p *ngIf="ownerForm.get('address')?.errors?.invalidAddress"
                                    class="mt-2 text-red-600 text-xs">
                                    Invalid address (select from the dropdown)
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="space-y-1">
                        <label class="subheading">
                            City <span class="text-red-600">*</span>
                        </label>
                        <div>
                            <div>
                                <input formControlName="city" type="text"
                                    [readonly]="verification.owner?.address?.isCity"
                                    [ngClass]="verification.owner?.address.isCity ? '': 'border-red-600 dark:border-red-600'" />
                                    
                            </div>
                            <div *ngIf="submitted && ownerForm.get('address.city')?.errors">
                                <p *ngIf="ownerForm.get('address.city')?.errors?.required"
                                    class="pt-1 text-red-600 text-xs">
                                    City is required
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="space-y-1">
                        <label class="subheading">
                            State <span class="text-red-600">*</span>
                        </label>
                        <div>
                            <div>
                                <input formControlName="state" type="text"
                                    [readonly]="verification.owner?.address?.isState"
                                    [ngClass]="verification.owner?.address.isState ? '': 'border-red-600 dark:border-red-600'" />
                            </div>
                        </div>
                        <div *ngIf="submitted && ownerForm.get('address.state')?.errors">
                            <p *ngIf="ownerForm.get('address.state')?.errors?.required" class="pt-1 text-red-600 text-xs">
                                State is required
                            </p>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
        </section>
        <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
        <h2 class="heading">
            Documents
        </h2>
        <section class="mt-4 grid gap-4 sm:grid-cols-2">
            <ng-container formGroupName="documents">

                <div class="space-y-1">
                    <label class="subheading">
                        HIPAA Training Certificate
                    </label>
                    <div>
                        <div>
                            <input #hIPAATrainingCertificateImageInput type="file" accept="Image/*"
                                [disabled]="verification.documents?.isHIPAATrainingCertificateImage"
                                [readonly]="verification.documents?.isHIPAATrainingCertificateImage"
                                [ngClass]="verification.documents?.isHIPAATrainingCertificateImage ? 'cursor-not-allowed opacity-100' : 'cursor-pointer border-red-600 dark:border-red-600'" 
                                (change)="uploadDocumentImages(hIPAATrainingCertificateImageInput, document.get('hIPAATrainingCertificateImage'))" />
                        </div>
                        <div class="flex justify-between items-center mt-1">
                            <div class="text-xs text-gray-500">
                                <a *ngIf="document.get('hIPAATrainingCertificateImage')?.value" target="_blank"
                                    [href]="document.get('hIPAATrainingCertificateImage')?.value"
                                    class="underline text-blue-600 hover:text-blue-800 visited:text-blue-600">
                                    {{ getFileName(document.get('hIPAATrainingCertificateImage')?.value) }}
                                </a>
                            </div>
                            <div class="flex justify-end gap-2" *ngIf="document.get('hIPAATrainingCertificateImage')?.value && !verification.documents?.isHIPAATrainingCertificateImage">
                                <button
                                    type="button"
                                    [appCopyToClipboard]="document.get('hIPAATrainingCertificateImage')?.value" copyLabel="document link" copyTooltip="Copy link"
                                    class="p-1 border border-zinc-400 rounded bg-white text-black dark:bg-black dark:text-white dark:border-white/40 flex items-center justify-center outline-none focus:outline-none hover:border-primary hover:text-primary dark:hover:border-primary dark:hover:text-primary transition-colors">
                                    <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                                    </svg>
                                </button>
                                <button
                                    (click)="deleteFile(document.get('hIPAATrainingCertificateImage'), hIPAATrainingCertificateImageInput)"
                                    class="p-1 border rounded bg-red-600 flex items-center justify-center outline-none focus:outline-none">
                                    <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd"
                                            d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                            clip-rule="evenodd"></path>
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <p *ngIf="getRejectionReason('documents','hIPAATrainingCertificateImage')"
                            class="text-sm text-primary mt-1">
                            {{ getRejectionReason('documents','hIPAATrainingCertificateImage') }}
                        </p>
                    </div>
                </div>

                <div class="space-y-1">
                    <label class="subheading">
                        HIPAA Training Completion Date
                    </label>
                    <div>
                        <div class="datePicker">
                            <input type="text" name="time" id="time" formControlName="hIPAATrainingDate"
                            [readonly]="true"
                                [ngClass]="verification.documents?.isHIPAATrainingDate ? 'date-filled': 'date-empty'"
                                [owlDateTime]="dtHIPPATraining"
                                [owlDateTimeTrigger]="dtHIPPATraining"
                                [max]="document.get('hIPAATrainingExpireDate')?.value" />
                            <owl-date-time [pickerType]="'calendar'"
                                [disabled]="verification.documents?.isHIPAATrainingDate"
                                (afterPickerClosed)="onDateChange(document.get('hIPAATrainingDate'))"
                                #dtHIPPATraining></owl-date-time>
                        </div>
                        <p *ngIf="getRejectionReason('documents','hIPAATrainingDate')" class="text-sm text-primary mt-1">
                            {{ getRejectionReason('documents','hIPAATrainingDate') }}
                        </p>
                    </div>
                </div>

                <div class="space-y-1">
                    <label class="subheading">
                        HIPAA Training Expiration Date
                    </label>
                    <div>
                        <div class="datePicker">
                            <input type="text" name="time" id="time" formControlName="hIPAATrainingExpireDate" 
                            [readonly]="true"
                                [ngClass]="verification.documents?.isHIPAATrainingExpireDate ? 'date-filled': 'date-empty'"
                                [owlDateTime]="hIPAATrainingExpireDate"
                                [owlDateTimeTrigger]="hIPAATrainingExpireDate"
                                [min]="document.get('hIPAATrainingDate')?.value" />
                            <owl-date-time [pickerType]="'calendar'"
                                [disabled]="verification.documents?.isHIPAATrainingExpireDate"
                                (afterPickerClosed)="onDateChange(document.get('hIPAATrainingExpireDate'))"
                                #hIPAATrainingExpireDate></owl-date-time>
                        </div>
                        <p *ngIf="getRejectionReason('documents','hIPAATrainingExpireDate')" class="text-sm text-primary mt-1">
                            {{ getRejectionReason('documents','hIPAATrainingExpireDate') }}
                        </p>
                    </div>
                     <div *ngIf="submitted && document.get('hIPAATrainingExpireDate')?.errors">
                        <p *ngIf="document.get('hIPAATrainingExpireDate')?.errors?.dateMismatch" class="pt-1 text-red-600 text-xs">
                             HIPAA Training Expiration Date must be after HIPAA Training Completion Date
                        </p>
                    </div>
                </div>

                <div class="space-y-1">
                    <label class="subheading">
                        Fraud, Waste and Abuse Training Certificate
                    </label>
                    <div>
                        <div>
                            <input #fraudWasteAndAbuseCertificateImage type="file" accept="Image/*"
                                [disabled]="verification.documents?.isFraudWasteAndAbuseCertificateImage"
                                [readonly]="verification.documents?.isFraudWasteAndAbuseCertificateImage"
                                [ngClass]="verification.documents?.isFraudWasteAndAbuseCertificateImage ? 'cursor-not-allowed opacity-100' :'cursor-pointer border-red-600 dark:border-red-600'" 
                                (change)="uploadDocumentImages(fraudWasteAndAbuseCertificateImage, document.get('fraudWasteAndAbuseCertificateImage'))" />
                        </div>
                        <div class="flex justify-between items-center mt-1">
                            <div class="text-xs text-gray-500">
                                <a *ngIf="document.get('fraudWasteAndAbuseCertificateImage')?.value" target="_blank"
                                    [href]="document.get('fraudWasteAndAbuseCertificateImage')?.value"
                                    class="underline text-blue-600 hover:text-blue-800 visited:text-blue-600">
                                    {{ getFileName(document.get('fraudWasteAndAbuseCertificateImage')?.value) }}
                                </a>
                            </div>
                        <div class="flex justify-end gap-2" *ngIf="document.get('fraudWasteAndAbuseCertificateImage')?.value && !verification.documents?.isFraudWasteAndAbuseCertificateImage">
                            <button
                                type="button"
                                [appCopyToClipboard]="document.get('fraudWasteAndAbuseCertificateImage')?.value" copyLabel="document link" copyTooltip="Copy link"
                                class="p-1 border border-zinc-400 rounded bg-white text-black dark:bg-black dark:text-white dark:border-white/40 flex items-center justify-center outline-none focus:outline-none hover:border-primary hover:text-primary dark:hover:border-primary dark:hover:text-primary transition-colors">
                                <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                                </svg>
                            </button>
                            <button
                                (click)="deleteFile(document.get('fraudWasteAndAbuseCertificateImage'), fraudWasteAndAbuseCertificateImage)"
                                class="p-1 border rounded bg-red-600 flex items-center justify-center outline-none focus:outline-none">
                                <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd"
                                        d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                        clip-rule="evenodd"></path>
                                </svg>
                            </button>
                        </div>
                    </div>
                    </div>
                    <p *ngIf="getRejectionReason('documents','fraudWasteAndAbuseCertificateImage')"
                        class="text-sm text-primary mt-1">
                        {{ getRejectionReason('documents','fraudWasteAndAbuseCertificateImage') }}
                    </p>
                </div>

                <div class="space-y-1">
                    <label class="subheading">
                        Fraud, Waste and Abuse Training Completion Date
                    </label>
                    <div>
                        <div class="datePicker">
                            <input type="text" name="time" id="time" formControlName="fraudWasteAndAbuseCertificateDate"
                                [readonly]="true"
                                [ngClass]="verification.documents?.isFraudWasteAndAbuseCertificateDate ? 'date-filled': 'date-empty'"
                                [owlDateTime]="dtfraudWasteAndAbuseCertificateDate"
                                [owlDateTimeTrigger]="dtfraudWasteAndAbuseCertificateDate" 
                                [max]="document.get('fraudWasteAndAbuseCertificateExpireDate')?.value"/>
                            <owl-date-time [pickerType]="'calendar'"
                                [disabled]="verification.documents?.isFraudWasteAndAbuseCertificateDate"
                                (afterPickerClosed)="onDateChange(document.get('fraudWasteAndAbuseCertificateDate'))"
                                #dtfraudWasteAndAbuseCertificateDate></owl-date-time>
                        </div>
                        <p *ngIf="getRejectionReason('documents','fraudWasteAndAbuseCertificateDate')"
                            class="text-sm text-primary mt-1">
                            {{ getRejectionReason('documents','fraudWasteAndAbuseCertificateDate') }}
                        </p>
                    </div>
                </div>

                <div class="space-y-1">
                    <label class="subheading">
                        Fraud, Waste and Abuse Training Expiration Date
                    </label>
                    <div>
                        <div class="datePicker">
                            <input type="text" name="time" id="time" formControlName="fraudWasteAndAbuseCertificateExpireDate"
                                [readonly]="true"
                                [ngClass]="verification.documents?.isFraudWasteAndAbuseCertificateExpireDate ? 'date-filled': 'date-empty'"
                                [owlDateTime]="fraudWasteAndAbuseCertificateExpireDate"
                                [owlDateTimeTrigger]="fraudWasteAndAbuseCertificateExpireDate"
                                [min]="document.get('fraudWasteAndAbuseCertificateDate')?.value" />
                            <owl-date-time [pickerType]="'calendar'"
                                [disabled]="verification.documents?.isFraudWasteAndAbuseCertificateExpireDate"
                                (afterPickerClosed)="onDateChange(document.get('fraudWasteAndAbuseCertificateExpireDate'))"
                                #fraudWasteAndAbuseCertificateExpireDate></owl-date-time>
                        </div>
                        <p *ngIf="getRejectionReason('documents','fraudWasteAndAbuseCertificateExpireDate')"
                            class="text-sm text-primary mt-1">
                            {{ getRejectionReason('documents','fraudWasteAndAbuseCertificateExpireDate') }}
                        </p>
                    </div>
                        <div *ngIf="submitted && document.get('fraudWasteAndAbuseCertificateExpireDate')?.errors">
                            <p *ngIf="document.get('fraudWasteAndAbuseCertificateExpireDate')?.errors?.dateMismatch"
                                class="pt-1 text-red-600 text-xs">
                                Fraud, Waste and Abuse Training Expiration Date must be after Fraud, Waste and Abuse Training Completion Date
                            </p>
                        </div>
                </div>

                <div class="space-y-1">
                    <label class="subheading">
                        Signed Non-Disclosure Agreement
                    </label>
                    <div>
                        <div>
                            <input #nonDisclosureAgreementImageInput type="file" accept="Image/*"
                                [disabled]="verification.documents?.isNonDisclosureAgreementImage"
                                [readonly]="verification.documents?.isNonDisclosureAgreementImage"
                                [ngClass]="verification.documents?.isNonDisclosureAgreementImage ? 'cursor-not-allowed opacity-100' : 'cursor-pointer border-red-600 dark:border-red-600'" 
                                (change)="uploadDocumentImages(nonDisclosureAgreementImageInput, document.get('nonDisclosureAgreementImage'))" />
                        </div>
                        <div class="flex justify-between items-center mt-1">
                            <div class="text-xs text-gray-500">
                                <a *ngIf="document.get('nonDisclosureAgreementImage')?.value" target="_blank"
                                    [href]="document.get('nonDisclosureAgreementImage')?.value"
                                    class="underline text-blue-600 hover:text-blue-800 visited:text-blue-600">
                                    {{ getFileName(document.get('nonDisclosureAgreementImage')?.value) }}
                                </a>
                            </div>
                            <div class="flex justify-end gap-2" *ngIf="document.get('nonDisclosureAgreementImage')?.value && !verification.documents?.isNonDisclosureAgreementImage">
                                <button
                                    type="button"
                                    [appCopyToClipboard]="document.get('nonDisclosureAgreementImage')?.value" copyLabel="document link" copyTooltip="Copy link"
                                    class="p-1 border border-zinc-400 rounded bg-white text-black dark:bg-black dark:text-white dark:border-white/40 flex items-center justify-center outline-none focus:outline-none hover:border-primary hover:text-primary dark:hover:border-primary dark:hover:text-primary transition-colors">
                                    <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                                    </svg>
                                </button>
                                <button
                                    (click)="deleteFile(document.get('nonDisclosureAgreementImage'), nonDisclosureAgreementImageInput)"
                                    class="p-1 border rounded bg-red-600 flex items-center justify-center outline-none focus:outline-none">
                                    <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd"
                                            d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                            clip-rule="evenodd"></path>
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <p *ngIf="getRejectionReason('documents','nonDisclosureAgreementImage')"
                            class="text-sm text-primary mt-1">
                            {{ getRejectionReason('documents','nonDisclosureAgreementImage') }}
                        </p>
                    </div>

                </div>

                <div class="space-y-1">
                    <label class="subheading">
                        Signed Transportation Provider Agreement
                    </label>
                    <div>
                        <div>
                            <input #transportationProviderAgreementImageInput type="file" accept="Image/*"
                                [disabled]="verification.documents?.isTransportationProviderAgreementImage"
                                [readonly]="verification.documents?.isTransportationProviderAgreementImage"
                                [ngClass]="verification.documents?.isTransportationProviderAgreementImage ? 'cursor-not-allowed opacity-100' : 'cursor-pointer border-red-600 dark:border-red-600'"
                                (change)="uploadDocumentImages(transportationProviderAgreementImageInput, document.get('transportationProviderAgreementImage'))" />
                        </div>
                        <div class="flex justify-between items-center mt-1">
                            <div class="text-xs text-gray-500">
                                <a *ngIf="document.get('transportationProviderAgreementImage')?.value" target="_blank"
                                    [href]="document.get('transportationProviderAgreementImage')?.value"
                                    class="underline text-blue-600 hover:text-blue-800 visited:text-purple-600">
                                    {{ getFileName(document.get('transportationProviderAgreementImage')?.value) }}
                                </a>
                            </div>
                            <div class="flex justify-end gap-2"
                                *ngIf="document.get('transportationProviderAgreementImage')?.value && !verification.documents?.isTransportationProviderAgreementImage">
                                <button
                                    type="button"
                                    [appCopyToClipboard]="document.get('transportationProviderAgreementImage')?.value" copyLabel="document link" copyTooltip="Copy link"
                                    class="p-1 border border-zinc-400 rounded bg-white text-black dark:bg-black dark:text-white dark:border-white/40 flex items-center justify-center outline-none focus:outline-none hover:border-primary hover:text-primary dark:hover:border-primary dark:hover:text-primary transition-colors">
                                    <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                                    </svg>
                                </button>
                                <button
                                    (click)="deleteFile(document.get('transportationProviderAgreementImage'), transportationProviderAgreementImageInput)"
                                    class="p-1 border rounded bg-red-600 flex items-center justify-center outline-none focus:outline-none">
                                    <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd"
                                            d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                            clip-rule="evenodd"></path>
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <p *ngIf="getRejectionReason('documents','transportationProviderAgreementImage')"
                            class="text-sm text-primary mt-1">
                            {{ getRejectionReason('documents','transportationProviderAgreementImage') }}
                        </p>
                    </div>
                </div>

                <div class="space-y-1">
                    <label class="subheading">
                        W-9 Form
                    </label>
                    <div>
                        <div>
                            <input #w9ImageInput type="file" accept="Image/*"
                                [disabled]="verification.documents?.isW9Image"
                                [readonly]="verification.documents?.isW9Image"
                                [ngClass]="verification.documents?.isW9Image ? 'cursor-not-allowed opacity-100' : 'cursor-pointer border-red-600 dark:border-red-600'"
                                (change)="uploadDocumentImages(w9ImageInput, document.get('w9Image'))" />
                        </div>
                        <div class="flex justify-between items-center mt-1">
                            <div class="text-xs text-gray-500">
                                <a *ngIf="document.get('w9Image')?.value" target="_blank"
                                    [href]="document.get('w9Image')?.value"
                                    class="underline text-blue-600 hover:text-blue-800 visited:text-purple-600">
                                    {{ getFileName(document.get('w9Image')?.value) }}
                                </a>
                            </div>
                            <div class="flex justify-end gap-2" *ngIf="document.get('w9Image')?.value && !verification.documents?.isW9Image">
                                <button
                                    type="button"
                                    [appCopyToClipboard]="document.get('w9Image')?.value" copyLabel="document link" copyTooltip="Copy link"
                                    class="p-1 border border-zinc-400 rounded bg-white text-black dark:bg-black dark:text-white dark:border-white/40 flex items-center justify-center outline-none focus:outline-none hover:border-primary hover:text-primary dark:hover:border-primary dark:hover:text-primary transition-colors">
                                    <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                                    </svg>
                                </button>
                                <button (click)="deleteFile(document.get('w9Image'), w9ImageInput)"
                                    class="p-1 border rounded bg-red-600 flex items-center justify-center outline-none focus:outline-none">
                                    <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd"
                                            d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                            clip-rule="evenodd"></path>
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <p *ngIf="getRejectionReason('documents','w9Image')" class="text-sm text-primary mt-1">
                            {{ getRejectionReason('documents','w9Image') }}
                        </p>
                    </div>
                </div>

                <div class="space-y-1">
                    <label class="subheading">
                        Disclosure of Ownership
                    </label>
                    <div>
                        <div>
                            <input #disclosureofOwnershipImageInput type="file" accept="Image/*"
                                [disabled]="verification.documents?.isDisclosureofOwnershipImage"
                                [readonly]="verification.documents?.isDisclosureofOwnershipImage"
                                [ngClass]="verification.documents?.isDisclosureofOwnershipImage ? 'cursor-not-allowed opacity-100' : 'cursor-pointer border-red-600 dark:border-red-600'"
                                (change)="uploadDocumentImages(disclosureofOwnershipImageInput, document.get('disclosureofOwnershipImage'))" />
                        </div>
                        <div class="flex justify-between items-center mt-1">
                            <div class="text-xs text-gray-500">
                                <a *ngIf="document.get('disclosureofOwnershipImage')?.value" target="_blank"
                                    [href]="document.get('disclosureofOwnershipImage')?.value"
                                    class="underline text-blue-600 hover:text-blue-800 visited:text-purple-600">
                                    {{ getFileName(document.get('disclosureofOwnershipImage')?.value) }}
                                </a>
                            </div>
                            <div class="flex justify-end gap-2" *ngIf="document.get('disclosureofOwnershipImage')?.value && !verification.documents?.isDisclosureofOwnershipImage">
                                <button
                                    type="button"
                                    [appCopyToClipboard]="document.get('disclosureofOwnershipImage')?.value" copyLabel="document link" copyTooltip="Copy link"
                                    class="p-1 border border-zinc-400 rounded bg-white text-black dark:bg-black dark:text-white dark:border-white/40 flex items-center justify-center outline-none focus:outline-none hover:border-primary hover:text-primary dark:hover:border-primary dark:hover:text-primary transition-colors">
                                    <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                                    </svg>
                                </button>
                                <button
                                    (click)="deleteFile(document.get('disclosureofOwnershipImage'), disclosureofOwnershipImageInput)"
                                    class="p-1 border rounded bg-red-600 flex items-center justify-center outline-none focus:outline-none">
                                    <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd"
                                            d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                            clip-rule="evenodd"></path>
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <p *ngIf="getRejectionReason('documents','disclosureofOwnershipImage')"
                            class="text-sm text-primary mt-1">
                            {{ getRejectionReason('documents','disclosureofOwnershipImage') }}
                        </p>
                    </div>
                </div>

                <div class="space-y-1">
                    <label class="subheading">
                        EFT Form
                    </label>
                    <div>
                        <div>
                            <input #eFTFormImageInput type="file" accept="Image/*"
                                [disabled]="verification.documents?.isEFTFormImage"
                                [readonly]="verification.documents?.isEFTFormImage"
                                [ngClass]="verification.documents?.isEFTFormImage ? 'cursor-not-allowed opacity-100' : 'cursor-pointer border-red-600 dark:border-red-600'"
                                (change)="uploadDocumentImages(eFTFormImageInput, document.get('eFTFormImage'))" />
                        </div>
                        <div class="flex justify-between items-center mt-1">
                            <div class="text-xs text-gray-500">
                                <a *ngIf="document.get('eFTFormImage')?.value" target="_blank"
                                    [href]="document.get('eFTFormImage')?.value"
                                    class="underline text-blue-600 hover:text-blue-800 visited:text-purple-600">
                                    {{ getFileName(document.get('eFTFormImage')?.value) }}
                                </a>
                            </div>
                            <div class="flex justify-end gap-2" *ngIf="document.get('eFTFormImage')?.value && !verification.documents?.isEFTFormImage">
                                <button
                                    type="button"
                                    [appCopyToClipboard]="document.get('eFTFormImage')?.value" copyLabel="document link" copyTooltip="Copy link"
                                    class="p-1 border border-zinc-400 rounded bg-white text-black dark:bg-black dark:text-white dark:border-white/40 flex items-center justify-center outline-none focus:outline-none hover:border-primary hover:text-primary dark:hover:border-primary dark:hover:text-primary transition-colors">
                                    <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                                    </svg>
                                </button>
                                <button (click)="deleteFile(document.get('eFTFormImage'), eFTFormImageInput)"
                                    class="p-1 border rounded bg-red-600 flex items-center justify-center outline-none focus:outline-none">
                                    <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd"
                                            d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                            clip-rule="evenodd"></path>
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <p *ngIf="getRejectionReason('documents','eFTFormImage')" class="text-sm text-primary mt-1">
                            {{ getRejectionReason('documents','eFTFormImage') }}
                        </p>
                    </div>
                </div>

                <div class="space-y-1">
                    <label class="subheading">
                        Voided Check
                    </label>
                    <div>
                        <div>
                            <input #voidedCheckImageInput type="file" accept="Image/*"
                                [disabled]="verification.documents?.isVoidedCheckImage"
                                [readonly]="verification.documents?.isVoidedCheckImage"
                                [ngClass]="verification.documents?.isVoidedCheckImage ? 'cursor-not-allowed opacity-100' : 'cursor-pointer border-red-600 dark:border-red-600'"
                                (change)="uploadDocumentImages(voidedCheckImageInput, document.get('voidedCheckImage'))" />
                        </div>
                        <div class="flex justify-between items-center mt-1">
                            <div class="text-xs text-gray-500">
                                <a *ngIf="document.get('voidedCheckImage')?.value" target="_blank"
                                    [href]="document.get('voidedCheckImage')?.value"
                                    class="underline text-blue-600 hover:text-blue-800 visited:text-purple-600">
                                    {{ getFileName(document.get('voidedCheckImage')?.value) }}
                                </a>
                            </div>
                            <div class="flex justify-end gap-2" *ngIf="document.get('voidedCheckImage')?.value && !verification.documents?.isVoidedCheckImage">
                                <button
                                    type="button"
                                    [appCopyToClipboard]="document.get('voidedCheckImage')?.value" copyLabel="document link" copyTooltip="Copy link"
                                    class="p-1 border border-zinc-400 rounded bg-white text-black dark:bg-black dark:text-white dark:border-white/40 flex items-center justify-center outline-none focus:outline-none hover:border-primary hover:text-primary dark:hover:border-primary dark:hover:text-primary transition-colors">
                                    <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                                    </svg>
                                </button>
                                <button (click)="deleteFile(document.get('voidedCheckImage'), voidedCheckImageInput)"
                                    class="p-1 border rounded bg-red-600 flex items-center justify-center outline-none focus:outline-none">
                                    <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd"
                                            d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                            clip-rule="evenodd"></path>
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <p *ngIf="getRejectionReason('documents','voidedCheckImage')" class="text-sm text-primary mt-1">
                            {{ getRejectionReason('documents','voidedCheckImage') }}
                        </p>
                    </div>
                </div>

                <div class="space-y-1">
                    <label class="subheading">
                        Driver's Schedule
                    </label>
                    <div>
                        <div>
                            <input #driverScheduleImageInput type="file" accept="Image/*"
                                [disabled]="verification.documents?.isDriverScheduleImage"
                                [readonly]="verification.documents?.isDriverScheduleImage"
                                [ngClass]="verification.documents?.isDriverScheduleImage ? 'cursor-not-allowed opacity-100' : 'cursor-pointer border-red-600 dark:border-red-600'"
                                (change)="uploadDocumentImages(driverScheduleImageInput, document.get('driverScheduleImage'))" />
                        </div>
                        <div class="flex justify-between items-center mt-1">
                            <div class="text-xs text-gray-500">
                                <a *ngIf="document.get('driverScheduleImage')?.value" target="_blank"
                                    [href]="document.get('driverScheduleImage')?.value"
                                    class="underline text-blue-600 hover:text-blue-800 visited:text-purple-600">
                                    {{ getFileName(document.get('driverScheduleImage')?.value) }}
                                </a>
                            </div>
                            <div class="flex justify-end gap-2" *ngIf="document.get('driverScheduleImage')?.value && !verification.documents?.isDriverScheduleImage">
                                <button
                                    type="button"
                                    [appCopyToClipboard]="document.get('driverScheduleImage')?.value" copyLabel="document link" copyTooltip="Copy link"
                                    class="p-1 border border-zinc-400 rounded bg-white text-black dark:bg-black dark:text-white dark:border-white/40 flex items-center justify-center outline-none focus:outline-none hover:border-primary hover:text-primary dark:hover:border-primary dark:hover:text-primary transition-colors">
                                    <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                                    </svg>
                                </button>
                                <button
                                    (click)="deleteFile(document.get('driverScheduleImage'), driverScheduleImageInput)"
                                    class="p-1 border rounded bg-red-600 flex items-center justify-center outline-none focus:outline-none">
                                    <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd"
                                            d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                            clip-rule="evenodd"></path>
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <p *ngIf="getRejectionReason('documents','driverScheduleImage')" class="text-sm text-primary mt-1">
                            {{ getRejectionReason('documents','driverScheduleImage') }}
                        </p>
                    </div>

                </div>

                <div class="space-y-1">
                    <label class="subheading">
                        Vehicle's Schedule
                    </label>
                    <div>
                        <div>
                            <input #vehicleScheduleImageInput type="file" accept="Image/*"
                                [disabled]="verification.documents?.isVehicleScheduleImage"
                                [readonly]="verification.documents?.isVehicleScheduleImage"
                                [ngClass]="verification.documents?.isVehicleScheduleImage ? 'cursor-not-allowed opacity-100' : 'cursor-pointer border-red-600 dark:border-red-600'"
                                (change)="uploadDocumentImages(vehicleScheduleImageInput, document.get('vehicleScheduleImage'))" />
                        </div>
                        <div class="flex justify-between items-center mt-1">
                            <div class="text-xs text-gray-500">
                                <a *ngIf="document.get('vehicleScheduleImage')?.value" target="_blank"
                                    [href]="document.get('vehicleScheduleImage')?.value"
                                    class="underline text-blue-600 hover:text-blue-800 visited:text-purple-600">
                                    {{ getFileName(document.get('vehicleScheduleImage')?.value) }}
                                </a>
                            </div>
                            <div class="flex justify-end gap-2" *ngIf="document.get('vehicleScheduleImage')?.value && !verification.documents?.isVehicleScheduleImage">
                                <button
                                    type="button"
                                    [appCopyToClipboard]="document.get('vehicleScheduleImage')?.value" copyLabel="document link" copyTooltip="Copy link"
                                    class="p-1 border border-zinc-400 rounded bg-white text-black dark:bg-black dark:text-white dark:border-white/40 flex items-center justify-center outline-none focus:outline-none hover:border-primary hover:text-primary dark:hover:border-primary dark:hover:text-primary transition-colors">
                                    <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                                    </svg>
                                </button>
                                <button
                                    (click)="deleteFile(document.get('vehicleScheduleImage'), vehicleScheduleImageInput)"
                                    class="p-1 border rounded bg-red-600 flex items-center justify-center outline-none focus:outline-none">
                                    <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd"
                                            d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                            clip-rule="evenodd"></path>
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <p *ngIf="getRejectionReason('documents','vehicleScheduleImage')" class="text-sm text-primary mt-1">
                            {{ getRejectionReason('documents','vehicleScheduleImage') }}
                        </p>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Vehicle for Hire License
                    </label>
                    <div>
                        <div>
                            <input #vehicleForHireLicenseImageInput type="file" accept="Image/*"
                                [disabled]="verification.documents?.isVehicleForHireLicenseImage"
                                [readonly]="verification.documents?.isVehicleForHireLicenseImage"
                                [ngClass]="verification.documents?.isVehicleForHireLicenseImage ? 'cursor-not-allowed opacity-100' : 'cursor-pointer border-red-600 dark:border-red-600'"
                                (change)="uploadDocumentImages(vehicleForHireLicenseImageInput, document.get('vehicleForHireLicenseImage'))" />
                        </div>
                        <div class="flex justify-between items-center mt-1">
                            <div class="text-xs text-gray-500">
                                <a *ngIf="document.get('vehicleForHireLicenseImage')?.value" target="_blank"
                                    [href]="document.get('vehicleForHireLicenseImage')?.value"
                                    class="underline text-blue-600 hover:text-blue-800 visited:text-purple-600">
                                    {{ getFileName(document.get('vehicleForHireLicenseImage')?.value) }}
                                </a>
                            </div>
                            <div class="flex justify-end gap-2" *ngIf="document.get('vehicleForHireLicenseImage')?.value && !verification.documents?.isVehicleForHireLicenseImage">
                                <button
                                    type="button"
                                    [appCopyToClipboard]="document.get('vehicleForHireLicenseImage')?.value" copyLabel="document link" copyTooltip="Copy link"
                                    class="p-1 border border-zinc-400 rounded bg-white text-black dark:bg-black dark:text-white dark:border-white/40 flex items-center justify-center outline-none focus:outline-none hover:border-primary hover:text-primary dark:hover:border-primary dark:hover:text-primary transition-colors">
                                    <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                                    </svg>
                                </button>
                                <button
                                    (click)="deleteFile(document.get('vehicleForHireLicenseImage'), vehicleForHireLicenseImageInput)"
                                    class="p-1 border rounded bg-red-600 flex items-center justify-center outline-none focus:outline-none">
                                    <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd"
                                            d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                            clip-rule="evenodd"></path>
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <p *ngIf="getRejectionReason('documents','vehicleForHireLicenseImage')"
                            class="text-sm text-primary mt-1">
                            {{ getRejectionReason('documents','vehicleForHireLicenseImage') }}
                        </p>
                    </div>
                </div>

            </ng-container>
        </section>
        <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
        <h2 class="heading">
            Insurance Information
        </h2>
        <section class="mt-4 grid gap-4 sm:grid-cols-2">
            <ng-container formGroupName="insurance">
                <div class="space-y-1">
                    <label class="subheading">
                        General Liability Insurance
                    </label>
                    <div>
                        <div>
                            <input #generalLiabilityInsuranceImageInput type="file" accept="Image/*"
                                [disabled]="verification.insurance?.isGeneralLiabilityInsuranceImage"
                                [readonly]="verification.insurance?.isGeneralLiabilityInsuranceImage"
                                [ngClass]="verification.insurance?.isGeneralLiabilityInsuranceImage ? 'cursor-not-allowed opacity-100' : 'cursor-pointer border-red-600 dark:border-red-600'"
                                (change)="uploadDocumentImages(generalLiabilityInsuranceImageInput, insurance.get('generalLiabilityInsuranceImage'))" />
                        </div>
                        <div class="flex justify-between items-center mt-1">
                            <div class="text-xs text-gray-500">
                                <a *ngIf="insurance.get('generalLiabilityInsuranceImage')?.value" target="_blank"
                                    [href]="insurance.get('generalLiabilityInsuranceImage')?.value"
                                    class="underline text-blue-600 hover:text-blue-800 visited:text-purple-600">
                                    {{ getFileName(insurance.get('generalLiabilityInsuranceImage')?.value) }}
                                </a>
                            </div>
                            <div class="flex justify-end gap-2"
                                *ngIf="insurance.get('generalLiabilityInsuranceImage')?.value && !verification.insurance?.isGeneralLiabilityInsuranceImage">
                                <button
                                    type="button"
                                    [appCopyToClipboard]="insurance.get('generalLiabilityInsuranceImage')?.value" copyLabel="document link" copyTooltip="Copy link"
                                    class="p-1 border border-zinc-400 rounded bg-white text-black dark:bg-black dark:text-white dark:border-white/40 flex items-center justify-center outline-none focus:outline-none hover:border-primary hover:text-primary dark:hover:border-primary dark:hover:text-primary transition-colors">
                                    <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                                    </svg>
                                </button>
                                <button
                                    (click)="deleteFile(insurance.get('generalLiabilityInsuranceImage'), generalLiabilityInsuranceImageInput)"
                                    class="p-1 border rounded bg-red-600 flex items-center justify-center outline-none focus:outline-none">
                                    <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd"
                                            d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                            clip-rule="evenodd"></path>
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <p *ngIf="getRejectionReason('insurance','generalLiabilityInsuranceImage')"
                            class="text-sm text-primary mt-1">
                            {{ getRejectionReason('insurance','generalLiabilityInsuranceImage') }}
                        </p>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        General Liability Date
                    </label>
                    <div>
                        <div class="datePicker">
                            <input type="text" name="time" id="time" formControlName="generalLiabilityInsuranceDate"
                                [readonly]="true"
                                [ngClass]="verification.insurance?.isGeneralLiabilityInsuranceDate ? 'date-filled': 'date-empty'"
                                [owlDateTime]="dtgeneralLiabilityInsuranceDate"
                                [owlDateTimeTrigger]="dtgeneralLiabilityInsuranceDate" 
                                [max]="insurance.get('generalLiabilityInsuranceExpireDate')?.value"/>
                            <owl-date-time [pickerType]="'calendar'"
                            [disabled]="verification.insurance?.isGeneralLiabilityInsuranceDate"
                                (afterPickerClosed)="onDateChange(insurance.get('generalLiabilityInsuranceDate'))"
                                #dtgeneralLiabilityInsuranceDate></owl-date-time>
                        </div>
                        <p *ngIf="getRejectionReason('insurance','generalLiabilityInsuranceDate')"
                            class="text-sm text-primary mt-1">
                            {{ getRejectionReason('insurance','generalLiabilityInsuranceDate') }}
                        </p>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        General Liability Expiration Date
                    </label>
                    <div>
                        <div class="datePicker">
                            <input type="text" name="time" id="time" formControlName="generalLiabilityInsuranceExpireDate"
                                [readonly]="true"
                                [ngClass]="verification.insurance?.isGeneralLiabilityInsuranceExpireDate ? 'date-filled': 'date-empty'"
                                [owlDateTime]="generalLiabilityInsuranceExpireDate"
                                [owlDateTimeTrigger]="generalLiabilityInsuranceExpireDate"
                                 [min]="insurance.get('generalLiabilityInsuranceDate')?.value" />
                            <owl-date-time [pickerType]="'calendar'"
                            [disabled]="verification.insurance?.isGeneralLiabilityInsuranceExpireDate"
                                (afterPickerClosed)="onDateChange(insurance.get('generalLiabilityInsuranceExpireDate'))"
                                #generalLiabilityInsuranceExpireDate></owl-date-time>
                        </div>
                    </div>
                    <div *ngIf="submitted && insurance.get('generalLiabilityInsuranceExpireDate')?.errors">
                        <p *ngIf="insurance.get('generalLiabilityInsuranceExpireDate')?.errors?.dateMismatch"
                            class="pt-1 text-red-600 text-xs">
                            General Liability Expiration Date must be after General Liability Date
                        </p>
                    </div>
                    <p *ngIf="getRejectionReason('insurance','generalLiabilityInsuranceExpireDate')"
                        class="text-sm text-primary mt-1">
                        {{ getRejectionReason('insurance','generalLiabilityInsuranceExpireDate') }}
                    </p>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Auto Liability Insurance
                    </label>
                    <div>
                        <div>
                            <input #autoLiabilityInsuranceImageInput type="file" accept="Image/*"
                                [disabled]="verification.insurance?.isAutoLiabilityInsuranceImage"
                                [readonly]="verification.insurance?.isAutoLiabilityInsuranceImage"
                                [ngClass]="verification.insurance?.isAutoLiabilityInsuranceImage ? 'cursor-not-allowed opacity-100' : 'cursor-pointer border-red-600 dark:border-red-600'" 
                                (change)="uploadDocumentImages(autoLiabilityInsuranceImageInput, insurance.get('autoLiabilityInsuranceImage'))" />
                        </div>
                        <div class="flex justify-between items-center mt-1">
                            <div class="text-xs text-gray-500">
                                <a *ngIf="insurance.get('autoLiabilityInsuranceImage')?.value" target="_blank"
                                    [href]="insurance.get('autoLiabilityInsuranceImage')?.value"
                                    class="underline text-blue-600 hover:text-blue-800 visited:text-purple-600">
                                    {{ getFileName(insurance.get('autoLiabilityInsuranceImage')?.value) }}
                                </a>
                            </div>
                            <div class="flex justify-end gap-2" *ngIf="insurance.get('autoLiabilityInsuranceImage')?.value && !verification.insurance?.isAutoLiabilityInsuranceImage">
                                <button
                                    type="button"
                                    [appCopyToClipboard]="insurance.get('autoLiabilityInsuranceImage')?.value" copyLabel="document link" copyTooltip="Copy link"
                                    class="p-1 border border-zinc-400 rounded bg-white text-black dark:bg-black dark:text-white dark:border-white/40 flex items-center justify-center outline-none focus:outline-none hover:border-primary hover:text-primary dark:hover:border-primary dark:hover:text-primary transition-colors">
                                    <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                                    </svg>
                                </button>
                                <button
                                    (click)="deleteFile(insurance.get('autoLiabilityInsuranceImage'), autoLiabilityInsuranceImageInput)"
                                    class="p-1 border rounded bg-red-600 flex items-center justify-center outline-none focus:outline-none">
                                    <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd"
                                            d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                            clip-rule="evenodd"></path>
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <p *ngIf="getRejectionReason('insurance','autoLiabilityInsuranceImage')"
                            class="text-sm text-primary mt-1">
                            {{ getRejectionReason('insurance','autoLiabilityInsuranceImage') }}
                        </p>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Auto Liability Date
                    </label>
                    <div>
                        <div class="datePicker">
                            <input type="text" name="time" id="time" formControlName="autoLiabilityInsuranceDate"
                                [readonly]="true"
                                [ngClass]="verification.insurance?.isAutoLiabilityInsuranceDate ? 'date-filled': 'date-empty'"
                                [owlDateTime]="dtautoLiabilityInsuranceDate"
                                [owlDateTimeTrigger]="dtautoLiabilityInsuranceDate"
                                [max]="insurance.get('autoLiabilityInsuranceExpireDate')?.value" />
                            <owl-date-time [pickerType]="'calendar'"
                                [disabled]="verification.insurance?.isAutoLiabilityInsuranceDate"
                                (afterPickerClosed)="onDateChange(insurance.get('autoLiabilityInsuranceDate'))"
                                #dtautoLiabilityInsuranceDate></owl-date-time>
                        </div>
                        <p *ngIf="getRejectionReason('insurance','autoLiabilityInsuranceDate')"
                            class="text-sm text-primary mt-1">
                            {{ getRejectionReason('insurance','autoLiabilityInsuranceDate') }}
                        </p>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Auto Liability Expiration Date
                    </label>
                    <div>
                        <div class="datePicker">
                            <input type="text" name="time" id="time" formControlName="autoLiabilityInsuranceExpireDate"
                                [readonly]="true"
                                [ngClass]="verification.insurance?.isAutoLiabilityInsuranceExpireDate ? 'date-filled': 'date-empty'"
                                [owlDateTime]="dtautoLiabilityInsuranceExpireDate"
                                [owlDateTimeTrigger]="dtautoLiabilityInsuranceExpireDate"
                                [min]="insurance.get('autoLiabilityInsuranceDate')?.value" />
                            <owl-date-time [pickerType]="'calendar'"
                                [disabled]="verification.insurance?.isAutoLiabilityInsuranceExpireDate"
                                (afterPickerClosed)="onDateChange(insurance.get('autoLiabilityInsuranceExpireDate'))"
                                #dtautoLiabilityInsuranceExpireDate></owl-date-time>
                        </div>
                    </div>
                    <div *ngIf="submitted && insurance.get('autoLiabilityInsuranceExpireDate')?.errors">
                        <p *ngIf="insurance.get('autoLiabilityInsuranceExpireDate')?.errors?.dateMismatch"
                            class="pt-1 text-red-600 text-xs">
                            Auto Liability Expiration Date must be after Auto Liability Date
                        </p>
                    </div>
                    <p *ngIf="getRejectionReason('insurance','autoLiabilityInsuranceExpireDate')"
                        class="text-sm text-primary mt-1">
                        {{ getRejectionReason('insurance','autoLiabilityInsuranceExpireDate') }}
                    </p>
                </div>
                  <div class="space-y-1">
                    <label class="subheading">
                       COI For Worker Compensation
                    </label>
                    <div>
                        <div>
                            <input #workerCOIImageInput type="file" accept="Image/*"
                                [disabled]="verification.insurance?.isWorkerCOIImage"
                                [readonly]="verification.insurance?.isWorkerCOIImage"
                                [ngClass]="verification.insurance?.isWorkerCOIImage ? 'cursor-not-allowed opacity-100' : 'cursor-pointer border-red-600 dark:border-red-600'"
                                (change)="uploadDocumentImages(workerCOIImageInput, insurance.get('workerCOIImage'))" />
                        </div>
                        <div class="flex justify-between items-center mt-1">
                            <div class="text-xs text-gray-500">
                                <a *ngIf="insurance.get('workerCOIImage')?.value" target="_blank"
                                    [href]="insurance.get('workerCOIImage')?.value"
                                    class="underline text-blue-600 hover:text-blue-800 visited:text-purple-600">
                                    {{ getFileName(insurance.get('workerCOIImage')?.value) }}
                                </a>
                            </div>
                            <div class="flex justify-end gap-2"
                                *ngIf="insurance.get('workerCOIImage')?.value && !verification.insurance?.isWorkerCOIImage">
                                <button
                                    type="button"
                                    [appCopyToClipboard]="insurance.get('workerCOIImage')?.value" copyLabel="document link" copyTooltip="Copy link"
                                    class="p-1 border border-zinc-400 rounded bg-white text-black dark:bg-black dark:text-white dark:border-white/40 flex items-center justify-center outline-none focus:outline-none hover:border-primary hover:text-primary dark:hover:border-primary dark:hover:text-primary transition-colors">
                                    <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                                    </svg>
                                </button>
                                <button
                                    (click)="deleteFile(insurance.get('workerCOIImage'), workerCOIImageInput)"
                                    class="p-1 border rounded bg-red-600 flex items-center justify-center outline-none focus:outline-none">
                                    <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd"
                                            d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                            clip-rule="evenodd"></path>
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <p *ngIf="getRejectionReason('insurance','workerCOIImage')" class="text-sm text-primary mt-1">
                            {{ getRejectionReason('insurance','workerCOIImage') }}
                        </p>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        COI For Worker Compensation Expiration Date
                    </label>
                    <div>
                        <div class="datePicker">
                            <input type="text" name="time" id="time" formControlName="workerCOIImageExpireDate"
                                [readonly]="verification.insurance?.isWorkerCOIImageExpireDate"
                                [ngClass]="verification.insurance?.isWorkerCOIImageExpireDate ? '': 'border-red-600 dark:border-red-600'"
                                [owlDateTime]="dtworkerCOIImageExpireDate"
                                [owlDateTimeTrigger]="dtworkerCOIImageExpireDate" />
                            <owl-date-time [pickerType]="'calendar'"
                            [disabled]="verification.insurance?.isWorkerCOIImageExpireDate"
                                (afterPickerClosed)="onDateChange(insurance.get('workerCOIImageExpireDate'))"
                                #dtworkerCOIImageExpireDate></owl-date-time>
                        </div>
                        <p *ngIf="getRejectionReason('insurance','workerCOIImageExpireDate')"
                            class="text-sm text-primary mt-1">
                            {{ getRejectionReason('insurance','workerCOIImageExpireDate') }}
                        </p>
                    </div>
                </div>
            </ng-container>
        </section>
        <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
        <h2 class="heading">
            Bank Information
        </h2>
        <section class="mt-4 grid gap-4 sm:grid-cols-2">
            <ng-container formGroupName="bankDetails">
                <div class="space-y-1">
                    <label class="subheading">
                        Bank Name
                    </label>
                    <div>
                        <div>
                            <input formControlName="name" type="tel" [readonly]="verification.bankDetails?.isName"
                                [ngClass]="verification.bankDetails?.isName ? '': 'border-red-600 dark:border-red-600'" />
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Account Number
                    </label>
                    <div>
                        <div>
                            <input formControlName="accountNumber" type="text"
                                [readonly]="verification.bankDetails?.isAccountNumber"
                                [ngClass]="verification.bankDetails?.isAccountNumber ? '': 'border-red-600 dark:border-red-600'" />
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Routing Number
                    </label>
                    <div>
                        <div>
                            <input formControlName="routingNumber" type="text"
                                [readonly]="verification.bankDetails?.isRoutingNumber"
                                [ngClass]="verification.bankDetails?.isRoutingNumber ? '': 'border-red-600 dark:border-red-600'"  />
                        </div>
                    </div>
                </div>
            </ng-container>
        </section>
        <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
        <h2 class="heading">
            Tax Information
        </h2>
        <section class="mt-4 grid gap-4 sm:grid-cols-2">
            <ng-container formGroupName="taxInformation">
                <div class="space-y-1">
                    <label class="subheading">
                     Name
                    </label>
                    <div>
                        <div>
                            <input formControlName="name" type="tel" [readonly]="verification.taxInformation?.isName"
                                [ngClass]="verification.taxInformation?.isName ? '': 'border-red-600 dark:border-red-600'" />
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Npi
                    </label>
                    <div>
                        <div>
                            <input formControlName="npi" type="text"
                                [readonly]="verification.taxInformation?.isNpi"
                                [ngClass]="verification.taxInformation?.isNpi ? '': 'border-red-600 dark:border-red-600'" />
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Tax Id
                    </label>
                    <div>
                        <div>
                            <input formControlName="taxId" type="text"
                                [readonly]="verification.taxInformation?.isTaxId"
                                [ngClass]="verification.taxInformation?.isTaxId ? '': 'border-red-600 dark:border-red-600'"  />
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Taxonomy
                    </label>
                    <div>
                        <div>
                            <input formControlName="taxonomy" type="text"
                                [readonly]="verification.taxInformation?.isTaxonomy"
                                [ngClass]="verification.taxInformation?.isTaxonomy ? '': 'border-red-600 dark:border-red-600'"  />
                        </div>
                    </div>
                </div>
            </ng-container>
        </section>
         <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
        <h2 class="heading">
            Focal Person Information
        </h2>
        <section class="mt-4 grid gap-4 sm:grid-cols-2">
            <ng-container formGroupName="focalPersonInformation">
                <div class="space-y-1">
                    <label class="subheading">
                     Name
                    </label>
                    <div>
                        <div>
                            <input formControlName="name" type="tel" [readonly]="verification.focalPersonInformation?.isName"
                                [ngClass]="verification.focalPersonInformation?.isName ? '': 'border-red-600 dark:border-red-600'" />
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Email
                    </label>
                    <div>
                        <div>
                            <input formControlName="email" type="email"
                                [readonly]="verification.focalPersonInformation?.isEmail"
                                [ngClass]="verification.focalPersonInformation?.isEmail ? '': 'border-red-600 dark:border-red-600'" />
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Contact Number
                    </label>
                    <div>
                        <div>
                            <input formControlName="contactNumber" type="text"
                                [readonly]="verification.focalPersonInformation?.isContactNumber"
                                [ngClass]="verification.focalPersonInformation?.isContactNumber ? '': 'border-red-600 dark:border-red-600'"  />
                        </div>
                         <div>
                            <p *ngIf="submitted && (focalPersonForm.get('contactNumber')?.errors?.minlength || focalPersonForm.get('contactNumber')?.errors?.maxlength)"
                                class="pt-1 text-red-600 text-xs">
                                Minimum 10 digits are required and maximum 11 digits are allowed
                            </p>
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Phone Number
                    </label>
                    <div>
                        <div>
                            <input formControlName="phoneNumber" type="text"
                                [readonly]="verification.focalPersonInformation?.isPhoneNumber"
                                [ngClass]="verification.focalPersonInformation?.isPhoneNumber ? '': 'border-red-600 dark:border-red-600'"  />
                        </div>
                        <div>
                            <p *ngIf="submitted && (focalPersonForm.get('phoneNumber')?.errors?.minlength || focalPersonForm.get('phoneNumber')?.errors?.maxlength)"
                                class="pt-1 text-red-600 text-xs">
                                Minimum 10 digits are required and maximum 11 digits are allowed
                            </p>
                        </div>
                    </div>
                </div>
            </ng-container>
        </section>
        <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
        <section class="flex justify-end gap-4">
            <button *ngIf="companyId && getInvalidFields().length" class="btn btn-secondary" type="button" (click)="sendInvalidFields()">
                Request Review
            </button>
            <button type="submit" class="btn btn-secondary">
                {{companyId ? 'Update' : 'Create'}}
            </button>
        </section>
    </form>
</div>
</div>